import {main} from "../main";
export default {
    wxSDK(params) {
        return main.get('/client/mobile/weixin/sign/get',params);
    },
    //通过code获取openId
    getWeixinOpenId(params) {
        return main.get(`/client/mobile/weixin/openId/get`, {params:params});
    },
    createOrderPay(params){
        return main.post('/pay/weixin/order',params);
    },
    createOrderPay2(params){
        return main.post('/pay/weixin/order2',params);
    },

}